import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useDispatch } from 'react-redux';
import { activeUserList } from '../../../redux/slices/spotlight';

const LoggedInUsers = () => {
    const dispatch = useDispatch();
    const [activeUser, setactiveUser] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageLimit, setPageLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState();

    console.log(activeUser, "activeUser")


    const getActiveUserListing = (page, limit) => {
        setLoading(true);
        let params = {
            page: page ? page : currentPage,
            limit: limit ? limit : pageLimit,
        };
        dispatch(
            activeUserList({
                ...params,
                cb(res) {
                    if (res.data) {
                        setLoading(false);
                        setactiveUser(res?.data?.payload?.data);
                        setTotalPage(res?.data?.payload?.total_pages);
                    }
                },
            })
        );
    };

    const handlePageClick = (e) => {
        const pageNo = e.selected + 1;
        setCurrentPage(pageNo);
        getActiveUserListing(pageNo, pageLimit);
    };


    useEffect(() => {
        getActiveUserListing();
    }, []);

    const role = {
        1: "Buyer",
        2: "Supplier"
    }

    return (
        <div className='containerBox adminDashbord'>
            <div className='searchFilter'>
                <h3 className='headTxtBlueSmall mb-3'>Active Users</h3>
            </div>
            <div className="table-responsive">
                <table className="manageUserTable tableOverflow  userTable mt-5">
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Company</th>
                            <th>Email</th>
                            <th>Plan</th>
                            <th>Role</th>
                            <th>User Id</th>
                            <th>Login Date</th>
                            <th>Login Time</th>
                        </tr>
                    </thead>
                    {!loading && (
                        <>
                            {activeUser?.length > 0 ? (
                                <tbody>
                                    {activeUser?.map((data, index) => {
                                        const companyDetails = data?.userInfo?.is_invited === 2 ? data?.userInfo?.user_selected_company_information.user_company_information : data?.userInfo?.user_company_information
                                        const userInfo = data?.userInfo || {}
                                        return (
                                            <tr key={index}>
                                                <td> {userInfo?.user_profile?.first_name || "N/A"} </td> {/* Firstnmae */}
                                                <td> {userInfo?.user_profile?.last_name || "N/A"} </td>  {/* Last Name */}
                                                <td> {companyDetails?.company_name || "N/A"} </td>  {/* Company */}
                                                <td> {data?.email || "N/A"} </td>  {/* Email */}
                                                <td> {userInfo?.membership_details?.name || "N/A"}</td>  {/* Plan */}
                                                <td> {role[userInfo?.user_role?.role_id] || "N/A"}</td>  {/* Role */}
                                                <td> {data?.user_id || "N/A"}</td>  {/* User Id */}
                                                <td> {new Date(data?.login_date_time).toLocaleDateString()} </td>  {/* Login Date */}
                                                <td> {new Date(data?.login_date_time).toLocaleTimeString()} </td>  {/* Login Time */}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            ) : (
                                <span className="text-center">No data found</span>
                            )}
                        </>
                    )}
                </table>
            </div>
            {loading && (
                <div className="d-flex justify-content-center py-5 mx-auto">
                    <div className="spinner-grow text-primary" role="status"></div>
                </div>
            )}
            <div className="col-12 ">
                <div className="customPagination mt-4">
                    <div className="pagination">
                        {activeUser?.length > 0 ? (
                            <ReactPaginate
                                // nextLabel={'Next ' + <span>{'>>'}</span>}
                                nextLabel={
                                    <span>
                                        Next <span className="double-arrow">{">>"}</span>
                                    </span>
                                }
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                // pageRangeDisplayed={pageCount}  // Show only the starting 2 and last 2 pages
                                marginPagesDisplayed={2}
                                // pageRangeDisplayed={pageCount}
                                pageCount={totalPage}
                                // previousLabel={'<< Previous'}
                                previousLabel={
                                    <span>
                                        <span className="double-arrow h5">{"<<"}</span> Previous
                                    </span>
                                }
                                renderOnZeroPageCount={null}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoggedInUsers;